import React, { useContext, useState } from 'react';
import { Context } from '@front10/helpers/dist/Context';
// import PropTypes from 'prop-types';
import Input from '../../elements/Input';
import Checkbox from '../../elements/Checkbox';
import Text from '../../elements/Text';
import useStyles from '@front10/helpers/dist/UseStyles';

import PhoneInput from 'react-phone-input-2';

import Col from '../../elements/Col';
import Box from '../../elements/Box';
import Button from '../../elements/Button';
import LocationSelector from '../../controls/LocationSelector';
import AirportIataCode from '../../containers/_components/AirportIataCode';

import InlineFilters from '../../controls/InlineFilters/ReducedInlineFilterMobile';

const Form = ({
  firstName,
  lastName,
  phoneNumber,
  email,
  locations: { origin },
  locations,
  navigation,
  dispatch,
  isFetchData,
  isMobile,
  contentSecondary,
  form,
  form: {
    filters: { availableFilters },
    firstName: firstNameSettings,
    lastName: lastNameSettings,
    origin: originSettings,
    originDestinationSettings,
    email: emailSettings,
    phoneNumber: phoneNumberSettings,
    checkbox: checkboxSettings
  },
  callToActionStatus,
  showAlertButton,
  showInformation,
  userInteract,
  setUserInteract
}) => {
  const { direction, translate, theme } = useContext(Context);

  const [showError, setShowError] = useState(false);
  const [checked, setChecked] = useState(checkboxSettings?.isChecked ?? false);
  const [error, setError] = useState({
    firstName: '',
    lastName: '',
    email: '',
    origin: ''
  });

  const isLoading = callToActionStatus === 'LOADING';

  const validEmailRegex = RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  const validPhoneNumberRegex = RegExp(/^[0-9]+$/i);

  const gridStyles = {
    'grid-template-columns': `repeat(${
      availableFilters.includes('Origin') && !isMobile ? 3 : 2
    }, 1fr)`
  };

  function renderItem(item, locationProps) {
    return <AirportIataCode item={item} {...locationProps.listItem} />;
  }

  const formInvalid = React.useMemo(() => {
    // if (userInteract) {
    let formInvalid = false;
    let errors = error;
    Object.keys(error).forEach((key) => {
      if (error[key] !== '') {
        formInvalid = true;
      }
    });
    availableFilters.forEach((item) => {
      switch (item) {
        case 'FirstName': {
          if (firstNameSettings.required) {
            formInvalid = firstName.value.length === 0 || formInvalid;
            errors.firstName =
              firstName.value.length === 0
                ? translate('cmp-newsletter-form-error-first-name', 'First name is required')
                : '';
          }
          break;
        }
        case 'LastName': {
          if (lastNameSettings.required) {
            formInvalid = lastName.value.length === 0 || formInvalid;
            errors.lastName =
              lastName.value.length === 0
                ? translate('cmp-newsletter-form-error-last-name', 'Last name is required')
                : '';
          }
          break;
        }
        case 'Origin': {
          if (originSettings.required) {
            formInvalid = !Boolean(origin.value) || formInvalid;
            errors.origin = !Boolean(origin.value) ? 'cmp-newsletter-form-error-origin' : '';
          }
          break;
        }
        case 'OriginMobile': {
          if (originDestinationSettings?.components?.origin.required) {
            formInvalid = !Boolean(origin.value) || formInvalid;
            errors.origin = !Boolean(origin.value) ? 'cmp-newsletter-form-error-origin' : '';
          }
          break;
        }
        case 'Email': {
          if (emailSettings.required) {
            formInvalid = email.value.length === 0 || Boolean(errors.email) || formInvalid;
            errors.email =
              email.value.length === 0
                ? translate('cmp-newsletter-form-error-email-empty', 'Email is required')
                : validEmailRegex.test(email.value)
                ? ''
                : translate('cmp-newsletter-form-error-email-invalid', 'Email is not valid');
          }
          break;
        }
        case 'PhoneNumber': {
          if (phoneNumberSettings.required) {
            formInvalid = phoneNumber.value.length === 0 || formInvalid;
            errors.phoneNumber =
              email.value.length === 0
                ? translate(
                    'cmp-newsletter-form-error-phone-number-empty',
                    'Phone number is required'
                  )
                : validPhoneNumberRegex.test(phoneNumber.value)
                ? ''
                : translate(
                    'cmp-newsletter-form-error-phone-number-invalid',
                    'Wrong phone number format'
                  );
          }
          break;
        }
        default:
          break;
      }
    });
    setError(errors);
    return formInvalid;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableFilters, email, firstName, lastName, origin, phoneNumber, userInteract, error]);

  const handleCallToAction = () => {
    setUserInteract(true);
    const isFormInvalid = formInvalid;
    if (isFormInvalid) {
      setShowError(true);
    } else {
      form?.cta?.onClick();
      setShowError(false);
      setChecked(false);
    }
  };

  const [classNamePhoneNumber, stylePhoneNumber] = useStyles(phoneNumberSettings, {
    direction,
    theme
  });

  const [inputValues, setInputValues] = React.useState({
    firstName: firstName.lastValue,
    lastName: lastName.lastValue,
    email: email.lastValue,
    phoneNumber: phoneNumber.lastValue
  });
  const [prevInputValues, setPrevInputValues] = React.useState({});

  React.useEffect(() => {
    setPrevInputValues(inputValues);
  }, [inputValues]);

  let elements = {
    FirstName: (
      <div class="First-Name" style={{ position: 'relative' }}>
        <Input
          placeholder={translate('cmp-newsletter-first-name-placeholder', 'First Name')}
          disabled={isFetchData}
          {...firstName}
          {...firstNameSettings}
          onChange={(e) => {
            firstName?.onChange(e.target.value);
          }}
          showDescription={showError && Boolean(error.firstName)}
          invalid={showError && Boolean(error.firstName)}
          ariaInvalid={showError && Boolean(error.firstName)}
          ariaLabelInvalidDescription={showError && error.firstName}
          description={showError && error.firstName}
          name={'firstName'}
          className={showError && Boolean(error.firstName) ? 'fr-input-invalid-wrapper' : ''}
          rightIcons={firstName?.value ? ['close'] : []}
          autoCorrect="off"
          autoComplete="off"
          spellCheck="off"
          onRightIconClick={firstName.onClear}
          onBlur={() => {
            firstName?.onBlur(prevInputValues.firstName);
            setInputValues({ ...inputValues, firstName: firstName.lastValue });
          }}
        />
        {firstNameSettings.required && (
          <Box
            className={showError && Boolean(error.firstName) ? 'fr-input-asterisk-invalid' : ''}
            {...firstNameSettings?.asterisk}
          >
            *
          </Box>
        )}
      </div>
    ),
    LastName: (
      <div class="Last-Name" style={{ position: 'relative' }}>
        <Input
          placeholder={translate('cmp-newsletter-last-name-placeholder', 'Last Name')}
          disabled={isFetchData}
          {...lastName}
          {...firstNameSettings}
          {...lastNameSettings}
          onChange={(e) => {
            lastName?.onChange(e.target.value);
          }}
          showDescription={showError && Boolean(error.lastName)}
          invalid={showError && Boolean(error.lastName)}
          ariaInvalid={showError && Boolean(error.lastName)}
          ariaLabelInvalidDescription={showError && error.lastName}
          description={showError && error.lastName}
          name={'lastName'}
          className={showError && Boolean(error.lastName) ? 'fr-input-invalid-wrapper' : ''}
          rightIcons={lastName?.value ? ['close'] : []}
          autoCorrect="off"
          autoComplete="off"
          spellCheck="off"
          onRightIconClick={lastName.onClear}
          onBlur={() => {
            lastName?.onBlur(prevInputValues.lastName);
            setInputValues({ ...inputValues, lastName: lastName.lastValue });
          }}
        />
        {lastNameSettings.required && (
          <Box
            className={showError && Boolean(error.lastName) ? 'fr-input-asterisk-invalid' : ''}
            {...firstNameSettings?.asterisk}
            {...lastNameSettings?.asterisk}
          >
            *
          </Box>
        )}
      </div>
    ),
    PhoneNumber: (
      <div class="Phone-Number">
        <PhoneInput
          disableDropdown
          buttonClass={phoneNumberSettings?.showFlag === false ? 'fr-d-none' : ''}
          inputClass={phoneNumberSettings?.showFlag === false ? 'fr-pl-1' : ''}
          disabled={isFetchData}
          {...phoneNumber}
          {...phoneNumberSettings}
          placeholder={translate('cmp-newsletter-phone-placeholder', 'Phone Number')}
          className={`${classNamePhoneNumber} ${isFetchData ? 'fr-input-wrapper-disabled' : ''}`}
          style={stylePhoneNumber}
          onBlur={() => {
            phoneNumber?.onBlur(prevInputValues.phoneNumber);
            setInputValues({ ...inputValues, phoneNumber: phoneNumber.lastValue });
          }}
        />
      </div>
    ),
    Origin: (
      <div class="Your-Origin">
        <LocationSelector
          flex="1"
          showLabel={false}
          {...originSettings}
          disabled={origin.disabled}
          defaultValue={origin.value}
          options={origin.data}
          loading={origin.isLoading}
          onChange={(e) => {
            origin.onChange(e);
          }}
          onClear={() => {
            origin.onClear();
          }}
          hasError={Boolean(error.origin)}
          showErrorLabel={Boolean(error.origin)}
          inputItem={{
            ...originSettings?.inputItem,
            errorLabelKey: error.origin
          }}
          itemRenderer={renderItem}
          dataTestId="locationSelector-origin"
          placeholder={translate('cmp-newsletter-origin-placeholder', 'Your Origin')}
          name="Origin"
        />
      </div>
    ),
    OriginMobile: (
      <InlineFilters
        dataTestId="interactiveMapContainerMobile"
        locations={locations}
        navigation={navigation}
        dispatch={dispatch}
        {...form}
        originDestinationSettings={{
          ...form?.originDestinationSettings,
          components: {
            ...form?.originDestinationSettings?.components,
            origin: {
              ...form?.originDestinationSettings?.components?.origin,
              hasError: Boolean(error.origin),
              showErrorLabel: Boolean(error.origin),
              inputItem: {
                ...form?.originDestinationSettings?.components?.origin?.inputItem,
                errorLabelKey: error.origin
              }
            }
          }
        }}
      />
    ),
    Email: (
      <div class="Email" style={{ position: 'relative' }}>
        <Input
          placeholder={translate('cmp-newsletter-email-placeholder', 'Email')}
          disabled={isFetchData}
          {...email}
          {...firstNameSettings}
          {...emailSettings}
          onChange={(e) => {
            email?.onChange(e.target.value);
          }}
          showDescription={showError && Boolean(error.email)}
          invalid={showError && Boolean(error.email)}
          ariaInvalid={showError && Boolean(error.email)}
          ariaLabelInvalidDescription={showError && error.email}
          description={showError && error.email}
          name={'email'}
          className={showError && Boolean(error.email) ? 'fr-input-invalid-wrapper' : ''}
          rightIcons={email?.value ? ['close'] : []}
          autoCorrect="off"
          autoComplete="off"
          spellCheck="off"
          onRightIconClick={email.onClear}
          onBlur={() => {
            email?.onBlur(prevInputValues.email);
            setInputValues({ ...inputValues, email: email.lastValue });
          }}
        />
        {emailSettings.required && (
          <Box
            className={showError && Boolean(error.email) ? 'fr-input-asterisk-invalid' : ''}
            {...firstNameSettings?.asterisk}
            {...emailSettings?.asterisk}
          >
            *
          </Box>
        )}
      </div>
    ),
    Checkbox: (
      <Checkbox
        {...checkboxSettings}
        className="custom-checkbox"
        isChecked={checked}
        onChange={() => {
          setChecked(!checked);
        }}
        labelStyles={{
          dangerouslySetInnerHTML: {
            __html: translate(
              'cmp-newsletter-privacy-policy-disclaimer',
              `I have read and accept the privacy policy`
            )
          },
          ...(checkboxSettings?.labelStyles ?? {})
        }}
      />
    )
  };

  return (
    <Col {...contentSecondary}>
      <Box {...form?.primarySection}>
        <Box className="fr-newsletter-container" cmp-styles={gridStyles}>
          {availableFilters.map((e) => elements[e])}
        </Box>
      </Box>
      <Box {...form?.secondarySection}>
        <Button
          className={showAlertButton ? 'fr-cta-loading' : 'fr-cta'}
          {...form?.cta}
          onClick={handleCallToAction}
          disabled={isLoading || (availableFilters.includes('Checkbox') && !checked)}
        >
          <Text>{translate('cmp-newsletter-cta-subscribe', 'Subscribe')}</Text>
        </Button>
      </Box>
    </Col>
  );
};

export default Form;
